"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "genMysql2AggregatedQuery", {
    enumerable: true,
    get: function() {
        return genMysql2AggregatedQuery;
    }
});
const _nocodbsdk = require("nocodb-sdk");
function genMysql2AggregatedQuery({ column, baseModelSqlv2, aggregation, column_query, parsedFormulaType, aggType, alias }) {
    let aggregationSql;
    const { dbDriver: knex } = baseModelSqlv2;
    let condnValue = "''";
    if ([
        _nocodbsdk.UITypes.CreatedTime,
        _nocodbsdk.UITypes.LastModifiedTime,
        _nocodbsdk.UITypes.Date,
        _nocodbsdk.UITypes.DateTime,
        _nocodbsdk.UITypes.Number,
        _nocodbsdk.UITypes.Decimal,
        _nocodbsdk.UITypes.Year,
        _nocodbsdk.UITypes.Currency,
        _nocodbsdk.UITypes.Duration,
        _nocodbsdk.UITypes.Time,
        _nocodbsdk.UITypes.Percent,
        _nocodbsdk.UITypes.Rollup,
        _nocodbsdk.UITypes.Links,
        _nocodbsdk.UITypes.ID
    ].includes(column.uidt) || [
        _nocodbsdk.FormulaDataTypes.DATE,
        _nocodbsdk.FormulaDataTypes.NUMERIC
    ].includes(parsedFormulaType)) {
        condnValue = 'NULL';
    } else if ([
        _nocodbsdk.UITypes.Rating
    ].includes(column.uidt)) {
        condnValue = 0;
    }
    if (aggType === 'common') {
        switch(aggregation){
            case _nocodbsdk.CommonAggregations.Count:
                aggregationSql = knex.raw(`COUNT(*)`);
                break;
            case _nocodbsdk.CommonAggregations.CountEmpty:
                if ([
                    _nocodbsdk.UITypes.JSON
                ].includes(column.uidt)) {
                    aggregationSql = knex.raw(`SUM(CASE WHEN JSON_LENGTH(??) IS NULL THEN 1 ELSE 0 END)`, [
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`SUM(CASE WHEN (??) IS NULL OR (??) = ${condnValue} THEN 1 ELSE 0 END)`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.CommonAggregations.CountFilled:
                if ([
                    _nocodbsdk.UITypes.CreatedTime,
                    _nocodbsdk.UITypes.LastModifiedTime,
                    _nocodbsdk.UITypes.Date,
                    _nocodbsdk.UITypes.DateTime,
                    _nocodbsdk.UITypes.Number,
                    _nocodbsdk.UITypes.Decimal,
                    _nocodbsdk.UITypes.Year,
                    _nocodbsdk.UITypes.Currency,
                    _nocodbsdk.UITypes.Duration,
                    _nocodbsdk.UITypes.Percent,
                    _nocodbsdk.UITypes.Time,
                    _nocodbsdk.UITypes.JSON,
                    _nocodbsdk.UITypes.Rollup,
                    _nocodbsdk.UITypes.Links,
                    _nocodbsdk.UITypes.ID,
                    _nocodbsdk.UITypes.LinkToAnotherRecord,
                    _nocodbsdk.UITypes.Lookup
                ].includes(column.uidt) || [
                    _nocodbsdk.FormulaDataTypes.DATE,
                    _nocodbsdk.FormulaDataTypes.NUMERIC
                ].includes(parsedFormulaType)) {
                    aggregationSql = knex.raw(`SUM(CASE WHEN (??) IS NOT NULL THEN 1 ELSE 0 END)`, [
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`SUM(CASE WHEN (??) IS NOT NULL AND (??) != ${condnValue} THEN 1 ELSE 0 END)`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.CommonAggregations.CountUnique:
                if ([
                    _nocodbsdk.UITypes.JSON
                ].includes(column.uidt)) {
                    aggregationSql = knex.raw(`COUNT(DISTINCT JSON_UNQUOTE(JSON_EXTRACT(??, '$')))`, [
                        column_query
                    ]);
                    break;
                }
                if ([
                    _nocodbsdk.UITypes.CreatedTime,
                    _nocodbsdk.UITypes.LastModifiedTime,
                    _nocodbsdk.UITypes.Date,
                    _nocodbsdk.UITypes.DateTime,
                    _nocodbsdk.UITypes.Number,
                    _nocodbsdk.UITypes.Decimal,
                    _nocodbsdk.UITypes.Year,
                    _nocodbsdk.UITypes.Currency,
                    _nocodbsdk.UITypes.Time,
                    _nocodbsdk.UITypes.Duration,
                    _nocodbsdk.UITypes.Percent,
                    _nocodbsdk.UITypes.Rollup,
                    _nocodbsdk.UITypes.Links,
                    _nocodbsdk.UITypes.ID,
                    _nocodbsdk.UITypes.LinkToAnotherRecord,
                    _nocodbsdk.UITypes.Lookup
                ].includes(column.uidt) || [
                    _nocodbsdk.FormulaDataTypes.DATE,
                    _nocodbsdk.FormulaDataTypes.NUMERIC
                ].includes(parsedFormulaType)) {
                    aggregationSql = knex.raw(`COUNT(DISTINCT CASE WHEN (??) IS NOT NULL THEN (??) END)`, [
                        column_query,
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`COUNT(DISTINCT CASE WHEN ?? IS NOT NULL AND ?? != ${condnValue} THEN ?? END)`, [
                    column_query,
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.CommonAggregations.PercentEmpty:
                if ([
                    _nocodbsdk.UITypes.JSON
                ].includes(column.uidt)) {
                    aggregationSql = knex.raw(`(SUM(CASE WHEN JSON_LENGTH(??) IS NULL THEN 1 ELSE 0 END) * 100.0 / NULLIF(COUNT(*), 0))`, [
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`(SUM(CASE WHEN (??) IS NULL OR (??) = ${condnValue} THEN 1 ELSE 0 END) * 100.0 / NULLIF(COUNT(*), 0))`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.CommonAggregations.PercentFilled:
                if ([
                    _nocodbsdk.UITypes.CreatedTime,
                    _nocodbsdk.UITypes.LastModifiedTime,
                    _nocodbsdk.UITypes.Date,
                    _nocodbsdk.UITypes.DateTime,
                    _nocodbsdk.UITypes.Number,
                    _nocodbsdk.UITypes.Time,
                    _nocodbsdk.UITypes.Decimal,
                    _nocodbsdk.UITypes.Year,
                    _nocodbsdk.UITypes.Currency,
                    _nocodbsdk.UITypes.Duration,
                    _nocodbsdk.UITypes.Percent,
                    _nocodbsdk.UITypes.JSON,
                    _nocodbsdk.UITypes.Rollup,
                    _nocodbsdk.UITypes.Links,
                    _nocodbsdk.UITypes.ID,
                    _nocodbsdk.UITypes.LinkToAnotherRecord,
                    _nocodbsdk.UITypes.Lookup
                ].includes(column.uidt) || [
                    _nocodbsdk.FormulaDataTypes.DATE,
                    _nocodbsdk.FormulaDataTypes.NUMERIC
                ].includes(parsedFormulaType)) {
                    aggregationSql = knex.raw(`(SUM(CASE WHEN (??) IS NOT NULL THEN 1 ELSE 0 END) * 100.0 / NULLIF(COUNT(*), 0))`, [
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`(SUM(CASE WHEN (??) IS NOT NULL AND (??) != ${condnValue} THEN 1 ELSE 0 END) * 100.0 / NULLIF(COUNT(*), 0))`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.CommonAggregations.PercentUnique:
                if ([
                    _nocodbsdk.UITypes.JSON
                ].includes(column.uidt)) {
                    aggregationSql = knex.raw(`COUNT(DISTINCT JSON_UNQUOTE(JSON_EXTRACT((??), '$'))) * 100.0 / NULLIF(COUNT(*), 0)`, [
                        column_query
                    ]);
                    break;
                }
                if ([
                    _nocodbsdk.UITypes.CreatedTime,
                    _nocodbsdk.UITypes.LastModifiedTime,
                    _nocodbsdk.UITypes.Date,
                    _nocodbsdk.UITypes.DateTime,
                    _nocodbsdk.UITypes.Number,
                    _nocodbsdk.UITypes.Decimal,
                    _nocodbsdk.UITypes.Year,
                    _nocodbsdk.UITypes.Time,
                    _nocodbsdk.UITypes.Currency,
                    _nocodbsdk.UITypes.Duration,
                    _nocodbsdk.UITypes.Percent,
                    _nocodbsdk.UITypes.Rollup,
                    _nocodbsdk.UITypes.Links,
                    _nocodbsdk.UITypes.ID,
                    _nocodbsdk.UITypes.LinkToAnotherRecord,
                    _nocodbsdk.UITypes.Lookup
                ].includes(column.uidt) || [
                    _nocodbsdk.FormulaDataTypes.DATE,
                    _nocodbsdk.FormulaDataTypes.NUMERIC
                ].includes(parsedFormulaType)) {
                    aggregationSql = knex.raw(`(COUNT(DISTINCT CASE WHEN ?? IS NOT NULL THEN ?? END) * 100.0 / NULLIF(COUNT(*), 0))`, [
                        column_query,
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`(COUNT(DISTINCT CASE WHEN ?? IS NOT NULL AND ?? != ${condnValue} THEN ?? END) * 100.0 / NULLIF(COUNT(*), 0))`, [
                    column_query,
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.CommonAggregations.None:
                break;
        }
    } else if (aggType === 'numerical') {
        switch(aggregation){
            case _nocodbsdk.NumericalAggregations.Avg:
                if (column.uidt === _nocodbsdk.UITypes.Rating) {
                    aggregationSql = knex.raw(`AVG(CASE WHEN (??) != ${condnValue} THEN (??) ELSE NULL END)`, [
                        column_query,
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`AVG((??))`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.NumericalAggregations.Max:
                aggregationSql = knex.raw(`MAX((??))`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.NumericalAggregations.Min:
                if (column.uidt === _nocodbsdk.UITypes.Rating) {
                    aggregationSql = knex.raw(`MIN(CASE WHEN (??) != ${condnValue} THEN (??) ELSE NULL END)`, [
                        column_query,
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`MIN((??))`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.NumericalAggregations.Sum:
                aggregationSql = knex.raw(`SUM((??)) `, [
                    column_query
                ]);
                break;
            case _nocodbsdk.NumericalAggregations.StandardDeviation:
                if (column.uidt === _nocodbsdk.UITypes.Rating) {
                    aggregationSql = knex.raw(`STDDEV((??))`, [
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`STDDEV((??))`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.NumericalAggregations.Range:
                if (column.uidt === _nocodbsdk.UITypes.Rating) {
                    aggregationSql = knex.raw(`(MAX((??)) - MIN(CASE WHEN (??) != ${condnValue} THEN (??) ELSE NULL END))`, [
                        column_query,
                        column_query,
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`(MAX((??)) - MIN((??)))`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.NumericalAggregations.Median:
                // This is the sqlite3 port median query. Need to use native mysql median query
                aggregationSql = knex.raw(`
  (
    SELECT AVG(??)
    FROM (
      SELECT ??
      FROM ??
      ORDER BY ??
      LIMIT 2 - (SELECT COUNT(*) FROM ??) % 2    -- Handle even/odd number of rows
      OFFSET (SELECT (COUNT(*) - 1) / 2 FROM ??) -- Calculate the median offset
    ) AS median_subquery
  )`, [
                    column_query,
                    column_query,
                    baseModelSqlv2.tnPath,
                    column_query,
                    baseModelSqlv2.tnPath,
                    baseModelSqlv2.tnPath
                ]);
                break;
            default:
                break;
        }
    } else if (aggType === 'boolean') {
        switch(aggregation){
            case _nocodbsdk.BooleanAggregations.Checked:
                aggregationSql = knex.raw(`SUM(CASE WHEN ?? = true THEN 1 ELSE 0 END)`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.BooleanAggregations.Unchecked:
                aggregationSql = knex.raw(`SUM(CASE WHEN ?? = false OR ?? IS NULL THEN 1 ELSE 0 END)`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.BooleanAggregations.PercentChecked:
                aggregationSql = knex.raw(`(SUM(CASE WHEN ?? = true THEN 1 ELSE 0 END) * 100.0 / NULLIF(COUNT(*), 0))`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.BooleanAggregations.PercentUnchecked:
                aggregationSql = knex.raw(`(SUM(CASE WHEN ?? = false OR ?? IS NULL THEN 1 ELSE 0 END) * 100.0 / NULLIF(COUNT(*), 0))`, [
                    column_query,
                    column_query
                ]);
                break;
            default:
                break;
        }
    } else if (aggType === 'date') {
        switch(aggregation){
            case _nocodbsdk.DateAggregations.EarliestDate:
                aggregationSql = knex.raw(`MIN(??)`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.DateAggregations.LatestDate:
                aggregationSql = knex.raw(`MAX(??)`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.DateAggregations.DateRange:
                aggregationSql = knex.raw(`TIMESTAMPDIFF(DAY, MIN(??), MAX(??))`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.DateAggregations.MonthRange:
                aggregationSql = knex.raw(`PERIOD_DIFF(DATE_FORMAT(MAX(??), '%Y%m'), DATE_FORMAT(MIN(??), '%Y%m'))`, [
                    column_query,
                    column_query
                ]);
                break;
            default:
                break;
        }
    } else if (aggType === 'attachment') {
        switch(aggregation){
            case _nocodbsdk.AttachmentAggregations.AttachmentSize:
                aggregationSql = knex.raw(`(SELECT SUM(JSON_EXTRACT(json_object, '$.size')) FROM ?? CROSS JOIN JSON_TABLE(CAST(?? AS JSON), '$[*]' COLUMNS (json_object JSON PATH '$')) AS json_array)`, [
                    baseModelSqlv2.tnPath,
                    column_query
                ]);
                break;
        }
    }
    if (aggregationSql) {
        if (![
            _nocodbsdk.AllAggregations.EarliestDate,
            _nocodbsdk.AllAggregations.LatestDate
        ].includes(aggregation)) {
            aggregationSql = knex.raw(`COALESCE(??, 0)`, [
                aggregationSql
            ]);
        }
        if (alias) {
            aggregationSql = knex.raw(`?? AS ??`, [
                aggregationSql,
                alias
            ]);
        }
    }
    return aggregationSql == null ? void 0 : aggregationSql.toQuery();
}
